export enum RoleType {
  User = 'USER',
  Editor = 'EDITOR',
  Admin = 'ADMIN'
}
export const ROLE_LABELS: Record<RoleType, string> = {
  [RoleType.User]: $localize `:@@role.user:User`,
  [RoleType.Editor]: $localize `:@@role.editor:Editor`,
  [RoleType.Admin]: $localize `:@@role.admin:Administrator`,
};
export const RoleOrder: Record<RoleType, number> = {
  [RoleType.User]: 1,
  [RoleType.Editor]: 2,
  [RoleType.Admin]: 3
};
export function compareRoles(a: RoleType, b: RoleType): number {
  return RoleOrder[a] - RoleOrder[b];
}
export function isRoleType(value: string): value is RoleType {
  return Object.values(RoleType).includes(value as RoleType);
}
